import React,{useEffect} from 'react';
import { Container, Typography, Button, Box, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import { buttonColor, buttonHoverColor, primaryColor } from '../../UtilColorPalate/UtilColorPalate';
import { useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
    const navigate=useNavigate();
    const handleNavigate=()=>{
        navigate('/shop');
    }

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on mount
      }, []);


     
  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', marginTop:"2%" }}>
      {/* <Paper
        elevation={3}
        sx={{ padding: '40px', borderRadius: '12px', backgroundColor: '#ffffff' }}
      > */}
        <Grid container direction="column" alignItems="center" spacing={4}>
          {/* Staggered Animations for Tick Icon */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
            >
              <motion.svg
                xmlns="http://www.w3.org/2000/svg"
                width="120"
                height="120"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4caf50"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                initial={{ pathLength: 0, rotate: 0 }}
                animate={{ pathLength: 1, rotate: 360 }}
                transition={{
                  duration: 1,
                  ease: 'easeInOut',
                  delay: 0.3,
                }}
              >
                <path d="M20 6L9 17l-5-5" />
              </motion.svg>
            </motion.div>
          </Grid>

          {/* Staggered Heading Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#2E7D32' }}>
                Thank You for Your Purchase!
              </Typography>
            </motion.div>
          </Grid>

          {/* Staggered Message Animation */}
          <Grid item>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7, ease: 'easeOut' }}
            >
              <Typography
                variant="h6"
                textAlign={"left"}
                color="textSecondary"
                sx={{ maxWidth: '500px', margin: '0 auto' }}
              >
                Your order has been successfully placed! We’re processing it and will send you a
                confirmation email shortly.
              </Typography>
            </motion.div>
          </Grid>

          {/* Bouncing Button Animation */}
          <Grid item>
            {/* <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.6,
                delay: 1,
                ease: 'easeOut',
                repeat: Infinity,
                repeatType: 'reverse',
                yoyo: 10,
              }}
            > */}
              <Button
                variant="contained"
                color={'primary'}
                 sx={{                    backgroundColor: buttonColor,
                 
                                                                                                     color: "#fff",
                                                                                                     textTransform: "none",
                                                                                                     padding: "5px 15px",
                                                                                                     borderRadius: "4px",
                                                                                                     "&:hover": { backgroundColor: buttonHoverColor },
                                                                                                   }}
                onClick={handleNavigate}
              >
                Continue Shopping
              </Button>
            {/* </motion.div> */}
          </Grid>
        </Grid>
      {/* </Paper> */}
    </Container>
  );
};

export default ThankYouPage;